import * as React from 'react'
import { SVGProps } from 'react'

const SvgLoadingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M8 1.334a6.688 6.688 0 0 1 4.748 2h-2.082a.667.667 0 1 0 0 1.333h2.762c.684 0 1.238-.555 1.238-1.238V.667a.667.667 0 0 0-1.333 0v1.385a7.987 7.987 0 0 0-13.3 5.215A.671.671 0 0 0 .7 8a.655.655 0 0 0 .66-.585A6.676 6.676 0 0 1 8 1.334ZM15.3 8a.655.655 0 0 0-.659.585 6.657 6.657 0 0 1-11.389 4.082h2.081a.667.667 0 0 0 0-1.334H2.571c-.683 0-1.237.554-1.238 1.237v2.763a.667.667 0 0 0 1.334 0v-1.385a7.987 7.987 0 0 0 13.3-5.215A.671.671 0 0 0 15.3 8Z'
      fill='#3071EE'
    />
  </svg>
)

export default SvgLoadingIcon
